import React from 'react'
import { Control, FieldErrors, UseFormRegister } from 'react-hook-form'

import { TFunction } from 'i18next'

import { Box, TextButton } from '@surglogs-app/ui'
import { InputField } from '@surglogs-app/ui.form'

interface MfaAuthenticatorAppVerifyProps {
  onForgotScanClick: () => void
  t: TFunction<any>
  errors: FieldErrors
  register: UseFormRegister<{ mfaCode: string }>
  control: Control<{ mfaCode: string }>
}

export const MfaAuthenticatorAppVerify = ({
  control,
  errors,
  register,
  t,
  onForgotScanClick,
}: MfaAuthenticatorAppVerifyProps) => {
  return (
    <>
      <Box {...{ my: 'md' }}>
        <InputField
          {...{
            ...register('mfaCode'),
            control,
            required: true,
            'aria-label': t('mfaSetup.step2.providedCode'),
            errors,
            formFieldProps: {
              t,
              translationsPrefix: 'mfaSetup.step2',
            },
          }}
        />
      </Box>
      <TextButton {...{ onClick: onForgotScanClick }}>
        {t('mfaSetup.step2.forgotScan')}
      </TextButton>
    </>
  )
}
